/**
 * constants/index.js
 *
 * Constantes utilizadas no módulo de CRM de Leads B2B.
 */

export const SALES_STAGES = [
    { key: "new_lead", label: "Novo Lead", color: "#3b82f6", bg: "rgba(59, 130, 246, 0.15)" },
    { key: "contacted", label: "Primeiro Contato", color: "#6366f1", bg: "rgba(99, 102, 241, 0.15)" },
    { key: "demo_scheduled", label: "Apres. Agendada", color: "#a855f7", bg: "rgba(168, 85, 247, 0.15)" },
    { key: "demo_done", label: "Apres. Realizada", color: "#ec4899", bg: "rgba(236, 72, 153, 0.15)" },
    { key: "trial_active", label: "Trial Ativo", color: "#eab308", bg: "rgba(234, 179, 8, 0.15)" },
    { key: "proposal_sent", label: "Proposta Enviada", color: "#f97316", bg: "rgba(249, 115, 22, 0.15)" },
    { key: "won", label: "Ganho ✅", color: "#22c55e", bg: "rgba(34, 197, 94, 0.15)" },
    { key: "lost", label: "Perdido ❌", color: "#ef4444", bg: "rgba(239, 68, 68, 0.15)" },
    { key: "cold", label: "Frio ❄️", color: "#06b6d4", bg: "rgba(6, 182, 212, 0.15)" }
];

export const LEAD_TEMPERATURES = {
    hot: { label: "Quente 🔴", color: "#ef4444", bg: "rgba(239, 68, 68, 0.12)" },
    warm: { label: "Morno 🟡", color: "#f59e0b", bg: "rgba(245, 158, 11, 0.12)" },
    cold: { label: "Frio 🔵", color: "#3b82f6", bg: "rgba(59, 130, 246, 0.12)" }
};

export const CONTACT_OUTCOMES = [
    { key: "no_answer", label: "Sem Resposta" },
    { key: "interested", label: "Interessado" },
    { key: "scheduled", label: "Agendou Apresentação" },
    { key: "objection", label: "Apresentou Objeção" },
    { key: "won", label: "Fechou Negócio" },
    { key: "lost", label: "Recusou / Perdido" }
];

export const LOSS_REASONS = [
    { key: "price", label: "Preço alto / Orçamento" },
    { key: "competitor", label: "Foi para concorrente" },
    { key: "no_need", label: "Sem necessidade atual" },
    { key: "no_time", label: "Sem tempo / falta de prioridade" },
    { key: "unresponsive", label: "Sem resposta após múltiplas tentativas" },
    { key: "trial_expired", label: "Trial expirou sem converter" },
    { key: "other", label: "Outro motivo" }
];

export const REOPEN_REASONS = [
    { key: "new_contact", label: "Novo contato espontâneo do lead" },
    { key: "changed_mind", label: "Mudou de ideia / Nova oportunidade" },
    { key: "win_back_responded", label: "Respondeu à campanha de win-back" },
    { key: "referral_new", label: "Indicação interna reativou interesse" },
    { key: "other", label: "Outro motivo" }
];

export const LEAD_SOURCES = [
    { key: "ads", label: "Anúncios (Google/Meta)" },
    { key: "referral", label: "Indicação" },
    { key: "organic", label: "Busca Orgânica" },
    { key: "event", label: "Evento Presencial" },
    { key: "cold_outreach", label: "Prospecção Ativa" }
];

// ─── Lead Score Tiers ───────────────────────────────────────────────────────
// Score 0-100: calculado automaticamente pelo sistema (ver platformLeadCadence.js)
// Componentes: stage progress (35) + last outcome (30) + recency (20) + source (10) - re-engagement penalty (15)
export const LEAD_SCORE_TIERS = [
    { min: 70, max: 100, label: "Alto Potencial",  color: "#22c55e", bg: "rgba(34,197,94,0.12)",   description: "Fechar agora — lead engajado e avançado no funil" },
    { min: 40, max: 69,  label: "Potencial Médio", color: "#f59e0b", bg: "rgba(245,158,11,0.12)", description: "Nutrir com conteúdo e follow-up estruturado" },
    { min: 0,  max: 39,  label: "Baixo Potencial", color: "#6b7280", bg: "rgba(107,114,128,0.12)", description: "Reativação ou arquivamento — não priorizar" },
];

export const getLeadScoreTier = (score) =>
    LEAD_SCORE_TIERS.find(t => score >= t.min && score <= t.max) || LEAD_SCORE_TIERS[2];

// ─── Playbook de Consultor por Estágio ──────────────────────────────────────
// Instrução resumida para o consultor ao abrir um card no CRM
export const STAGE_CONSULTANT_PLAYBOOK = {
    new_lead: {
        sla: "Primeiro contato em até 2h",
        goal: "Entender o perfil e agendar uma conversa de 15-30 min",
        action: "Ligar ou enviar WhatsApp pessoal (não template). Pesquisar a academia antes do contato.",
        message: "Mensagem pessoal apresentando o NeoApp e fazendo 1 pergunta sobre o desafio atual da academia.",
        redFlag: "Mais de 24h sem primeiro contato = lead esfria",
    },
    contacted: {
        sla: "Demo agendada em até 5 dias",
        goal: "Qualificar o lead e confirmar uma data para apresentação",
        action: "Perguntar sobre o maior desafio operacional. Oferecer demo express de 15 min.",
        message: "Template: saas_contacted_followup_1 (D+2) ou followup_2 (D+5)",
        redFlag: "Lead sem agenda após 5 dias → mover para Cold",
    },
    demo_scheduled: {
        sla: "Confirmar participação 1h antes",
        goal: "Garantir que a demo aconteça — taxa de no-show é o maior gargalo",
        action: "Enviar confirmação no dia. Personalizar apresentação com nome/logo da academia. Ligar se não aparecer.",
        message: "Template: saas_demo_confirmation (ao agendar) e saas_demo_noshow (D+1 sem comparecimento)",
        redFlag: "No-show sem retato em 3 dias → Cold",
    },
    demo_done: {
        sla: "Trial ativado em até 3 dias após a demo",
        goal: "Converter o interesse em trial — este é o ponto de maior queda",
        action: "Enviar recap + próximos passos em até 2h após a demo. No D+3 abordar a objeção específica. No D+7 oferta especial.",
        message: "D+1: saas_post_demo_d1 | D+3: saas_post_demo_d3 | D+7: saas_post_demo_d7",
        redFlag: "Sem resposta em 10 dias → Cold",
    },
    trial_active: {
        sla: "Fechamento antes do trial expirar (geralmente 14-30 dias)",
        goal: "Garantir ativação real (configurar 10+ alunos no sistema) para gerar valor e fechar",
        action: "Oferecer onboarding ativo. Monitorar logins. Celebrar cada configuração concluída. Criar urgência no D+12.",
        message: "D+3: saas_trial_check_in | D+7: saas_trial_urgency | D+12: saas_trial_last_call",
        redFlag: "Trial sem nenhum uso após 7 dias = cliente não vai converter",
    },
    proposal_sent: {
        sla: "Fechamento em até 15 dias",
        goal: "Eliminar a última objeção e fechar o contrato",
        action: "Ligar 24h após enviar a proposta. No D+5 perguntar sobre objeção específica. No D+10 fazer oferta especial por tempo limitado.",
        message: "D+2: saas_proposal_followup_1 | D+5: saas_proposal_followup_2 | D+10: saas_proposal_last_call",
        redFlag: "Sem resposta em 15 dias → Cold",
    },
    cold: {
        sla: "Reativação a cada 30 dias (automático)",
        goal: "Reaquecer o lead com novidade relevante ou mudança de contexto",
        action: "Não insistir com o mesmo pitch. Usar conteúdo diferente: case de sucesso, nova funcionalidade, promoção sazonal.",
        message: "D+30: saas_cold_reactivation | D+60: saas_cold_reactivation_2",
        redFlag: "Após D+90 sem resposta → Lost automático",
    },
    lost: {
        sla: "Win-back em D+90, arquivamento em D+120",
        goal: "Última tentativa de recuperação com nova abordagem",
        action: "Esperar 90 dias antes de tentar. Abordar com plano ou condição diferente. Aceitar a perda sem insistência.",
        message: "D+90: saas_win_back",
        redFlag: "Arquivamento automático em D+120",
    },
};

// Stages que permitem reabertura manual pelo consultor
export const REOPENABLE_STAGES = ["lost", "cold"];

// Stages arquivados automaticamente por tempo (cron)
export const AUTO_ARCHIVE_RULES = {
    won: { afterDays: 30, reason: "auto_won" },     // cliente gerenciado em /platform/tenants
    lost: { afterDays: 120, reason: "auto_lost" },  // sem resposta após win-back
};

// Stages terminais que ficam no topo do Kanban como colunas colapsáveis
export const TERMINAL_STAGES = ["won", "lost"];

// Stages ativos (pipeline principal, exibidos sempre)
export const ACTIVE_STAGES = ["new_lead", "contacted", "demo_scheduled", "demo_done", "trial_active", "proposal_sent"];
export const CLOSED_STAGES = ["won", "lost", "cold"];
